export default "__VITE_ASSET__IX0ZInHH__"